import Template from './DisplayListItemView.njk';
import "./DisplayListItemVIew.less";

export const DisplayListItemView = Marionette.View.extend({
  template: Template,
    className: "DisplayListItemView",
    triggers: {
        'click': 'click'
    },

    templateContext() {
        return {
            pictureUrl: "img/display.png"
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/view/components/DisplayListItemView.js